<template>
  <div class="  con_content">
    <div class="container">
      <div class="container_top h_48">
        合辑分类
      </div>

      <div>
        <!-- table组件 -->
        <div class="my_table">
          <!-- <Header class="my_title txt_l">
                        <span class='my_titleL'>
                            <Icon class="fw_900 " type="ios-list" size='30'/>     
                            筛选查询
                        </span>
                    </Header> -->
          <div class="my_search" style="margin-bottom:20px">
            <Row class="search_row">
              <div class="search_name">
                <Button
                  class="mR5"
                  type="info"
                  @click="
                    route = '/layout/circle/banner/add';
                    mTitle = '添加合辑分类';
                    rBtn = '添加';
                    addFun();
                  "
                >
                  <Icon type="md-add" />添加</Button
                >
              </div>
            </Row>
          </div>
        
        </div>
        <!-- table组件 -->
        <div class="my_table  ">
          <Header class="my_title txt_l">
            <span class="my_titleL">
              <Icon class="fw_900 " type="ios-list" size="30" />
              数据列表
            </span>

            <div class="ct_rgt">
              <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
            </div>
          </Header>
          <Table border row-key="id" :columns="columns1" :data="data1" ref="table">
            <!-- 图片 -->
            <template slot-scope="{ row }" slot="image">
              <div class="img_c">
                <img v-if="row.image" :src="row.image" alt="" />
              </div>
            </template>
            <!-- 展示类型 -->
            <template slot-scope="{ row }" slot="type">
              <span v-if="row.type == 0">动态</span>
              <span v-if="row.type == 1">商城</span>
            </template>

            <!-- 按钮 -->
            <template slot-scope="{ row }" slot="btn">
              <Poptip trigger="hover" content="编辑">
                <Button
                  class="padlr5"
                  size="small"
                  @click="
                    route = '/layout/circle/banner/edit';
                    mTitle = '编辑合辑分类';
                    rBtn = '修改';
                    editFun(row);
                  "
                  type="success"
                  icon="md-open"
                ></Button>
              </Poptip>
              <Poptip trigger="hover" content="删除">
                <Button
                  class="padlr5"
                  size="small"
                  @click="
                    route = '/layout/circle/banner/del';
                    delFun(row);
                  "
                  type="error"
                  icon="md-close"
                ></Button>
              </Poptip>
            </template>
          </Table>
        

          <!-- 编辑分类 -->
          <Modal
            v-model="modal1"
            :title="mTitle"
            class-name="vertical-center-modal"
          >
            <div slot="footer">
              <Button type="text" size="large" @click="cancel">取消</Button>
              <Button
                type="primary"
                size="large"
                v-if="mTitle == '添加合辑分类'"
                @click="addSubmit"
                >添加</Button
              >
              <Button
                type="primary"
                size="large"
                v-if="mTitle == '编辑合辑分类'"
                @click="editSubmit"
                >修改</Button
              >
            </div>
            <ul class="list_ul">
              <!-- 分类名称-->
              <li>
                <div class="list_title">
                  <span class="cRed">*</span> 分类名称 :
                </div>
                <div class="list_con">
                  <Input
                    v-model="submit.label"
                    type="text"
                    class="ipt"
                    placeholder="请输入分类名称"
                  />
                </div>
              </li>
              <!-- 上级类目 -->
              <li>
                <div class="list_title">
                  <span class="cRed">*</span> 上级类目 :
                </div>
                <div class="list_con relative">
                  <!-- 子组件 -->
                  <myselect 
                    :select="submit.parent"
                    :selects="cateId.selects"
                    @selectChild="selectChild"
                  ></myselect>
                  
                </div>
              </li>

              <!-- 当前图片-->
              <li>
                <div class="list_title">当前图片 :</div>
                <div class="list_con imgS">
                  <img :src="submit.image" v-if="submit.image" alt="" />
                  <img
                    src="../../../../public/images/head_01.png"
                    v-if="!submit.image"
                    alt=""
                  />
                </div>
              </li>

              <!-- 轮播图片 model5 -->
              <li>
                <div class="list_title"><span class="cRed">*</span> 图片 :</div>
                <div class="list_con">
                  <cropper @childFun="childFun2" :data="cropper_data"></cropper>
                </div>
              </li>

              <!-- 排序 -->
              <li>
                <div class="list_title"><span class="cRed">*</span> 排序 :</div>
                <div class="list_con">
                  <InputNumber
                    type="number"
                    class="ipt"
                    placeholder="请输入排序"
                    v-model="submit.listorder"
                  />
                </div>
              </li>

              <!-- 状态 -->
              <li>
                <div class="list_title">状态 :</div>
                <div class="list_con">
                  <i-switch
                    class="mSwitch"
                    v-model="submit.display"
                    @on-change="change_btn"
                  />
                </div>
              </li>
            </ul>
          </Modal>
          <!-- 确认删除框 -->
          <Modal
            v-model="delM"
            title="提示"
            @on-ok="delOk"
            class-name="vertical-center-modal"
          >
            <p>确定删除吗?</p>
          </Modal>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { format } from "path";
import CryptoJS from "crypto-js";
import cropper from "../../child_vue/vue_cropper.vue";
import myselect from "../../child_vue/select.vue";

const submitInit = {

  pid: 0,
  label: '',
  listorder: 0,
  image: "",
  title: "",
  parent: "",
  display: true
};

export default {
  name: "guanliyuan",
  data() {
    return {
      guid: null,
      route: null,
      token: "",
      search: "",
      rec: {
        //推荐选择
        recRow: null,
        recCheck: [],
        recAll: []
      },

      columns1: [],
      mTitle: "",
      rBtn: "",
      data1: [],
      page: {
        page: 1,
        size: 10,
        total: 0
      },

      checkGuid2: "",

      val: -1,

      modal1: false, //添加弹窗
      recBool: false, //推荐弹窗

      submit: submitInit,

      delM: false,

      type: [], //所属上级
      type2: [
        //展示类型
        { code: "0", name: "动态" },
        { code: "1", name: "商城" }
      ],

      image_back: null, //上传图片后返回值

      cropper_data: {
        btn_name: "上传图片",
        outputType: "jpeg", //生成图片格式
        type: "19", //图片分组
        vCropper: "5", //插件分组
        enlarge: "1", //倍数
        autoCropWidth: "200",
        autoCropHeight: "200"
      },

      child_val: null, //child 反馈
      cateId: {
        select: "",
        selects: []
      }
    };
  },
  created() {
    this.selectFun();

  },
  watch: {
    'submit.label': function(opt){
      this.submit.title = opt
    }
  },
  components: { cropper, myselect },
  props: ["uploadType"],
  computed: {
    is_change_layout() {
      return this.$store.getters.is_change_layout;
    },
    is_change_vCropper() {
      return this.$store.getters.is_change_vCropper;
    }
  },

  methods: {
     selectFun() {
      this.$myAjax
        .get(`admin/cate/tree?route=/layout/jurisdiction/admin/editor`)
        .then(res => {
          this.cateId.select = res.data.data[0].label;
          let selects = res.data.data;

          function fun(opt) {
            for (let i = 0; i < opt.length; i++) {
              opt[i].title = opt[i].label;
              if (opt[i].children && opt[i].children.length > 0) {
                fun(opt[i].children);
              }
            }
          }
          fun(selects);
          this.cateId.selects = selects;
          this.cateId.selects.unshift({id:0,title: '顶级类目',pid:0,label:'顶级类目'});
          console.log( this.cateId.selects)
        });
    },
    load() {
      var that = this;
      that.$myAjax
        .get(
          `admin/cate?route=/layout/jurisdiction/admin/edit`
        )
        .then(res => {
       
          that.data1 = res.data.data;

          that.columns1 = [
            { title: "分类名称", key: "label",tree: true, width: 200 },
            { title: "分类图标", slot: "image", align: "center", width: 150 },
            { title: "排序", key: "listorder", align: "center", width: 80 },
            {
              title: "状态",
              key: "display",
              align: "center",
              width: 110,
              render: (h, params) => {
                return h(
                  "i-switch",
                  {
                    props: {
                      size: "large",
                      value: params.row.display 
                    },
                    on: {
                      "on-change": value => {
                        that.$myAjax
                          .put(
                            "admin/service/album/changeStatus?route=/layout/circle/banner/edit",
                            {
                              id: params.row.id,
                              display: value
                            }
                          )
                          .then(res => {
                            that.load();
                          })
                          .catch(err => {
                            console.log(err);
                          });
                      }
                    }
                  },
                  [
                    h("span", {
                      slot: "open",
                      domProps: {
                        innerHTML: "开启"
                      }
                    }),
                    h("span", {
                      slot: "close",
                      domProps: {
                        innerHTML: "关闭"
                      }
                    })
                  ]
                );
              }
            },
            {
              title: "创建日期",
              key: "createTime",
              align: "center",
              minWidth: 100
            },
            {
              title: "操作",
              slot: "btn",
              align: "center",
              width: 180,
              fixed: "right"
            }
          ];

          that.$data_null.editor(that.data1);
        });
    },
    recChange(opt) {
      this.rec.recCheck = opt;
    },
    searchFun() {
      if (this.search) {
        this.$myAjax
          .get(
            `admin/service/album/search?page=${this.page.page}&&size=${this.page.size}&&title=${this.search}&&route=/layout/jurisdiction/admin/edit`
          )
          .then(res => {
            this.page.total = res.data.data.total;
            this.data1 = res.data.data.list;
          });
      } else {
        this.load();
      }
    },
    change_page() {
      this.load();
    },
    change_size(size) {
      this.size = size;
      this.load();
    },
    // 编辑
    editFun(res) {
      this.modal1 = true;
      this.submit = res;
   
      this.$canBtn(this.route).then(function(res_c) {});
    },

    //    编辑弹窗
    editSubmit() {
      var that = this;

      let data = this.submit;
      if (!data.label) {
        that.$Message.info({
          content: "请输入合辑标题",
          duration: 3
        });
      } else if ( data.pid !=0 && !data.pid) {
        console.log(data.pid)
        that.$Message.info({
          content: "请输入上级类目",
          duration: 3
        });
      } else if (!that.child_val) {
        that.$Message.info({
          content: "请上传图片",
          duration: 3
        });
      } else if ( !data.listorder && data.listorder != 0  ) {
        that.$Message.info({
          content: "请输入排序",
          duration: 3
        });
      } else {
        if (!that.child_val) {
          that.$myAjax
            .put("admin/cate/edit?route=" + that.route, data)
            .then(res => {
              if (res.data.code != 0) {
                that.load();
                that.cancel();
              }
            });
        } else {
          that.$upload(that.child_val).then(res => {
            that.submit.image = res.data.data.name;
            that.$myAjax
              .put("admin/cate/edit?route=" + that.route, data)
              .then(res => {
                if (res.data.code != 0) {
                  that.load();
                  that.cancel();
                }
              });
          });
        }
      }
    },
    cancel() {
      this.modal1 = false;
    },

    // 删除用户组
    delFun(res) {
      let that = this;

      that.guid = res.id;
      that.delM = true;
      that.$canBtn(that.route).then(function(res_c) {});
    },
    delOk() {
      let that = this;
      that.$myAjax
        .delete(
          "admin/cate/del?id=" + that.guid + "&route=" + that.route,
          {
            guid: that.guid
          }
        )
        .then(res => {
          that.load();
        });
    },

    // 顶部添加

    addFun(route) {
      this.modal1 = true;
      this.submit = submitInit;
      this.$canBtn(this.route).then(function(res_c) {});
    },
    addSubmit() {
      let that = this;
      let data = that.submit;
      if (!data.label) {
        that.$Message.info({
          content: "请输入合辑标题",
          duration: 3
        });
      } else if ( data.pid !=0 && !data.pid) {
        console.log(data.pid)
        that.$Message.info({
          content: "请输入上级类目",
          duration: 3
        });
      } else if (!that.child_val) {
        that.$Message.info({
          content: "请上传图片",
          duration: 3
        });
      } else if ( !data.listorder && data.listorder != 0  ) {
        that.$Message.info({
          content: "请输入排序",
          duration: 3
        });
      } else {
        that.$upload(that.child_val).then(res => {
          data.image = res.data.data.name;
          that.$myAjax
            .post("admin/cate/add?route=" + that.route, data)
            .then(res => {
              if (res.data.code != 0) {
                that.load();
                that.cancel();
              }
            });
        });
      }
    },
    cancel_add() {
      this.modal2 = false;
    },
    // 提交按钮
    change() {},
    change_btn(bool) {},
    recommendFun() {
      this.$myAjax
        .post("admin/service/album/setRecom?route=" + this.route, {
          checkedCates: this.rec.recCheck,
          id: this.rec.recRow.id
        })
        .then(res => {
          if (res.data.code != 0) {
            this.load();
            this.recBool = false;
          }
        });
    },
    selectChild(opt) {
      this.submit.cateId = opt[0].id;
    },
    // 剪切上传
    childFun2(data) {
      let that = this;
      that.child_val = data.pic_url;
    }
  },
  mounted: function() {
    var that = this;
    that.token = that.$store.state.token;

    that.vCropper = that.$store.state.vCropper;

    that.load();
  }
};
</script>
<style scoped>
.list_ul li {
  padding: 5px 10px !important;
}
/* 表格下方无翻页按钮时 */
.ivu-table-wrapper {
  margin-bottom: 50px;
}

.dis_none {
  display: none;
}

/* 弹窗 */
.list_ul {
  width: 100%;
  height: auto;
}
.list_ul li {
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 5px 0;
}
.list_ul .list_title {
  float: left;
  width: 26%;
  text-align: right;
  padding-right: 10px;
  line-height: 32px;
  font-size: 14px;
}
.list_ul .list_con {
  float: left;
  width: 60%;
}

.img_c {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 40px;
  border-radius: 3px;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}
.img_c img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 40px;
}
</style>



